import { render } from "./TaskCards.vue?vue&type=template&id=b645f556&scoped=true"
import script from "./TaskCards.vue?vue&type=script&lang=js"
export * from "./TaskCards.vue?vue&type=script&lang=js"

import "./TaskCards.vue?vue&type=style&index=0&id=b645f556&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b645f556"]])

export default __exports__